import { ExportSites } from "constants/exportSites";
import { AdvancedDraftingValidationStates } from "constants/draftingAttributes";
import { Species } from "constants/species";
import * as Yup from "yup";
import {
  doValidate,
  vendorRequiredValidation,
  sheepFieldsRequired,
  pregStatusValidation,
  sheepDraftingAttributesRequired,
  hornValidation,
  cattleAgeRequiredValidation,
  ErrorDict,
} from "./doValidate";

const stockLiveSheepSchema = Yup.object().shape({
  ...vendorRequiredValidation,
  ...sheepFieldsRequired,
  draftingAttributes: Yup.object({
    ...sheepDraftingAttributesRequired,
    ...pregStatusValidation,
  }).typeError("Advanced Drafting Details incomplete"),
});

const stockLiveCattleSchema = Yup.object().shape({
  draftingAttributes: Yup.object({
    ...hornValidation,
    ...cattleAgeRequiredValidation,
  }).typeError("Advanced Drafting Details incomplete"),
});

export const getStockliveValidationErrorsOrStatus = (
  saleLot: SaleLot,
): string | ErrorDict => {
  if (!saleLot.exportSites?.includes(ExportSites.STOCK_LIVE as ExportSite)) {
    return AdvancedDraftingValidationStates.DISABLED;
  }

  if (!saleLot.sale_round) {
    return {
      sale_round: "No round selected",
    };
  }

  let validationSchema = null;
  if (saleLot.sale_round.species_id === Species.CATTLE) {
    validationSchema = stockLiveCattleSchema;
  } else if (saleLot.sale_round.species_id === Species.SHEEP) {
    validationSchema = stockLiveSheepSchema;
  }

  if (validationSchema) {
    return (
      doValidate(validationSchema, saleLot) ||
      AdvancedDraftingValidationStates.SUCCESS
    );
  }
  return AdvancedDraftingValidationStates.DISABLED;
};
